import { createFileRoute } from '@tanstack/react-router'
import { RotationFormPage } from '~/components/routes/product-rotations/rotation-form-page'
import { ROTATIONS_EDIT } from '~/components/routes/product-rotations/rotation-ui'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/product-rotations/new')({
  staticData: {
    permission: ROTATIONS_EDIT,
  },
  component: NewProductRotationPage,
})
withRoutePermissions(Route)

function NewProductRotationPage() {
  return <RotationFormPage rotation={null} />
}
